module.exports = __webpack_public_path__ + "img/icon-back-arrow.266b36c5.svg";